import { render, staticRenderFns } from "./MediumIcon.vue?vue&type=template&id=7e5279aa&scoped=true&"
import script from "./MediumIcon.vue?vue&type=script&lang=js&"
export * from "./MediumIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5279aa",
  null
  
)

export default component.exports